import {defineField, defineType} from 'sanity'
import dotcomDestination from '../fragments/dotcom.destination'
import dotcomShip from '../fragments/dotcom.ship'

export default defineType({
  name: 'fyc-filters',
  type: 'object',

  fields: [
    defineField({
      ...dotcomDestination,
      name: 'filterByDestination',
      title: 'by Destination',
    }),
    defineField({
      ...dotcomShip,
      name: 'filterByShip',
      title: 'by Ship',
    }),
  ],
})
